import { action } from "typesafe-actions";
import { IApprovalQuote, IHandleApproval } from "./approvalQuote.types";
import { IDate } from "../../../components/Table/hooks/useDateFilter";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../..";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { AnyAction } from "redux";

export const FETCH_APPROVAL_QUOTE_LIST_PROGRESS =
  "FETCH_APPROVAL_QUOTE_LIST_PROGRESS";
export const FETCH_APPROVAL_QUOTE_LIST_SUCCESS =
  "FETCH_APPROVAL_QUOTE_LIST_SUCCESS";
export const FETCH_APPROVAL_QUOTE_LIST_FAILED =
  "FETCH_APPROVAL_QUOTE_LIST_FAILED";

export const fetchApprovalQuotesListProgress = () =>
  action(FETCH_APPROVAL_QUOTE_LIST_PROGRESS);
export const fetchApprovalQuotesListSuccess = (
  list: IApprovalQuote[],
  totalRecords: number,
) => action(FETCH_APPROVAL_QUOTE_LIST_SUCCESS, { list, totalRecords });
export const fetchApprovalQuotesListFailed = () =>
  action(FETCH_APPROVAL_QUOTE_LIST_FAILED);

export const fetchApprovalQuotesListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    status: string,
    date: IDate,
    searchValue: string,
    searchType: string[],
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchApprovalQuotesListProgress());
      let url = "";
      if (status !== "-1") {
        url = "&status=" + status;
      }
      let finalUrl = `/approval/get-approval?approval_type=quotes&status=REQUESTED&pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}${url}`;
      if (searchType.length > 0 && searchValue) {
        finalUrl = `/quotes/get-quotes?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&columns=${[
          searchType,
        ]}&value=${searchValue}`;
      }

      const res = await api.get(finalUrl);
      const data: IApprovalQuote[] = res.data.data.resultJoined;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchApprovalQuotesListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchApprovalQuotesListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const handleApprovalAsync =
  (
    data: IHandleApproval,
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post("/approval/handle-approval", data);
      let message = "Action success!";
      dispatch(
        showMessage({
          type: "success",
          displayAs: "snackbar",
          message: message,
        }),
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(true);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_APPROVAL_QUOTE_STATE = "CLEAR_APPROVAL_QUOTE_STATE";
export const clearApprovalQuoteState = () => action(CLEAR_APPROVAL_QUOTE_STATE);
